<template>
	<div>

		<breadcrumbs />

		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="row">
					<div class="col-sm-12">
						<!--START - User List -->
						<div class="element-wrapper">
							<h6 class="element-header capitalize">

							</h6>
							<div class="element-box-tp">
                                <div class="row">
                                    <div class="col-3">
                                        <div class="form-group">
                                            <input class="form-control" v-model="temp_name" :placeholder="t.template_name" type="text" required>
                                        </div>
                                    </div>
                                    <div class="col-2 p-1">
                                        <button class="btn btn-primary" @click="newTemplate" type="submit">{{ t.create_template }}</button>
                                    </div>
                                    <div class="col-2">
                                        <div class="form-group">
                                            <select style="width: 150px" name="x" class="form-control pull-right" v-model="default_template">
                                                <option v-for="c in list" :value="c.id">{{ c.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-2 p-1">
                                        <button class="btn btn-primary" @click="saveDefaultTemplate" type="submit">
                                            {{ t.set_default_template || 'Set Default Template' }}
                                        </button>
                                    </div>
                                </div>
                                <table class="table table-padded">
                                    <thead>
                                        <tr>
                                            <th>{{t.template_name}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="v in list">
                                            <td>
                                                <a href="javascript:;" @click="openTemplate(v)">
                                                    {{ v.name || "No name" }}
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
        <sweet-modal :title="template_name" width="90%" ref="umodal">
            <TemplateConfig :id="id" :name="template_name"/>
        </sweet-modal>
	</div>
</template>

<script>
    import feed from "@/mixins/feed.js"
    import TemplateConfig from './templateConfig'
    export default {
        name: 'templates',
        components: {TemplateConfig},
        mixins: [feed],
        data () {
            return {
                t: this.$root.t,
                list: [],
                temp_name: '',
                id: 0,
                sport: [],
                default_template: 0
            }
        },
        mounted() {
            this.fetchList()
            this.defaultTemplate()
        },
        methods: {
            saveDefaultTemplate () {
                this.saveDefTemplate(this.default_template).then(response => {
                    this.$notify({
                        group: 'custom-template',
                        text: this.t.processing.success,
                        type: 'success',
                        duration: 1000,
                        speed: 1000,
                        data: {}
                    })
                })
            },
            openTemplate(t) {
                this.id = t.id
                this.template_name = t.name
                this.$refs.umodal.open();
            },
            fetchList () {
                this.fetchTemplates().then(response => {
                    this.list = response.body.result
                })
            },
            defaultTemplate () {
                this.getDefaultTemplate().then(response => {
                    this.default_template = response.body.template
                })
            },
            newTemplate() {
                this.createTemplate(this.temp_name).then(response => {
                    this.fetchList()
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/feed/templates.vue